import { createConfigSelector } from '@americanexpress/travel-selectors';
import { createSelector } from 'reselect';

export const getMycaApiUrl = createConfigSelector('mycaApiUrl');

export const getMycaMemberApiUrl = createSelector(
  getMycaApiUrl,
  (mycaApiUrl) => `${mycaApiUrl}/api/servicing/v1/member`
);
